import React, { useState, useEffect } from 'react';
import { getUser } from '../components/Functions';
import axios from 'axios';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import Auth from '../components/Auth';
import ExcelJS from 'exceljs';
import Nav from '../components/Nav';
import '../css/Llamadas.css';


const Llamadas = () => {
    const [nombre, setNombre] = useState('');
    const [apellidos, setApellidos] = useState('');
    const [telefono, setTelefono] = useState('');
    const [mail, setMail] = useState('');
    const [nivel_estudios, setNivelEstudios] = useState('');
    const [nivel_ingles, setNivelIngles] = useState('');
    const [curso_interes, setCursoInteres] = useState('');
    const [como_conocio, setComoConocio] = useState('');
    const [grupo_joven, setGrupoJoven] = useState('');
    const [trabaja, setTrabaja] = useState('');
    const [sector, setSector] = useState('');
    const [comentarios, setComentarios] = useState('');
    const [provincia, setProvincia] = useState('');
    const [otros_comentarios, setOtrosComentarios] = useState('');
    const [usuario, setUsuario] = useState('');
    const [message, setMessage] = useState('');
    const [results, setResults] = useState([]);
    const [nombreUsuario, setNombreUsuario] = useState('');
    const [usuarios, setUsuarios] = useState([]);
    const [usuarioSeleccionado] = useState('');
    const [fechaInicio, setFechaInicio] = useState('');
    const [fechaFin, setFechaFin] = useState('');





    // Validación de caracteres especiales en campos no permitidos
    const valoresEspeciales = (input) => {
        const regex = /^[a-zñA-ZÑ0-9._@ ]*$/;
        return regex.test(input);
    };

    // Función para manejar el cambio de entrada y convertir a mayúsculas
    const cambiarValores = (setter, value) => {
        if (value === "" || valoresEspeciales(value)) {
            setter(value.toUpperCase());
        }
    };

    // Estado para la fecha de hoy (valor predeterminado para ultima_llamada)
    const [ultima_llamada, setUltimaLlamada] = useState('');

    // Obtener la fecha actual en formato ISO (AAAA-MM-DD)
    useEffect(() => {
        const today = new Date().toISOString().split('T')[0];
        setUltimaLlamada(today);
    }, []);

    //extraer el nombre de usuario
    useEffect(() => {
        (async () => {
            const datosAcceso = localStorage.getItem('datosAcceso');
            if (datosAcceso) {
                const { email } = JSON.parse(datosAcceso);
                try {
                    const userData = await getUser(email);
                    setNombreUsuario(userData?.name || '');
                } catch (error) {
                    console.error('Error al obtener los datos del usuario:', error);
                }
            }
        })();
    }, []);



    // Verificar que los campos requeridos no esten vacios

    const camposObligatorios = ["nombre", "apellidos", "telefono", "mail",
        "nivel_estudios", "nivel_ingles", "curso_interes", "como_conocio", "grupo_joven", "trabaja", "sector",
        "comentarios", "provincia", "otros_comentarios"];


    const camposVacios = () => {
        for (const field of camposObligatorios) {
            if (!eval(field)) {
                return `Falta rellenar el campo "${field}"`;
            }
        }
        return ''; // Si no falta ningún campo, devuelve una cadena vacía
    };



    const resetFormulario = () => {
        setNombre('');
        setApellidos('');
        setTelefono('');
        setMail('');
        setNivelEstudios('');
        setNivelIngles('');
        setCursoInteres('');
        setComoConocio('');
        setGrupoJoven('');
        setTrabaja('');
        setSector('');
        setComentarios('');
        setProvincia('');
        setOtrosComentarios('');
    };

    const registrarLlamada = async (e) => {
        e.preventDefault();

        const validationMessage = camposVacios();
        if (validationMessage) {
            setMessage(validationMessage);
            return; // Si falta algún campo, evita continuar con el registro
        }

        const llamadaData = {
            ultima_llamada: ultima_llamada,
            nombre: nombre,
            apellidos: apellidos,
            telefono: telefono,
            mail: mail,
            nivel_estudios: nivel_estudios,
            nivel_ingles: nivel_ingles,
            curso_interes: curso_interes,
            como_conocio: como_conocio,
            grupo_joven: grupo_joven,
            trabaja: trabaja,
            sector: sector,
            comentarios: comentarios,
            provincia: provincia,
            otros_comentarios: otros_comentarios,
            usuario: nombreUsuario,
        };

        try {
            const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/llamada`, llamadaData);

            setMessage('Llamada creada correctamente');
            resetFormulario()
        } catch (error) {
            console.error('Error al crear la llamada:', error.message);
            setMessage('Error al crear la llamada');
        }
    };

    //funcion para buscar datos

    const buscarLlamada = async (e) => {
        e.preventDefault();

        // Filtrar los parámetros para eliminar aquellos que están vacíos
        const buscarData = {
            nombre: nombre && nombre.trim(),
            apellidos: apellidos && apellidos.trim(),
            telefono: telefono && telefono.trim(),
            mail: mail && mail.trim(),
            nivel_estudios: nivel_estudios && nivel_estudios.trim(),
            nivel_ingles: nivel_ingles && nivel_ingles.trim(),
            curso_interes: curso_interes && curso_interes.trim(),
            como_conocio: como_conocio && como_conocio.trim(),
            grupo_joven: grupo_joven && grupo_joven.trim(),
            trabaja: trabaja && trabaja.trim(),
            sector: sector && sector.trim(),
            comentarios: comentarios && comentarios.trim(),
            provincia: provincia && provincia.trim(),
            otros_comentarios: otros_comentarios && otros_comentarios.trim(),
            usuario: usuario && usuario.trim(),
            fechaInicio: fechaInicio && fechaInicio.trim(),
            fechaFin: fechaFin && fechaFin.trim(),
        };

        // Construir la URL de búsqueda solo con los parámetros que tienen un valor
        const params = Object.entries(buscarData)
            .filter(([_key, value]) => value !== '')
            .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
            .join('&');
        const searchUrl = `${process.env.REACT_APP_BACKEND_URL}/llamada/buscar?${params}`;
        try {
            const response = await axios.post(searchUrl);
            setResults(response.data);
            console.log('Respuesta de búsqueda:', response.data);
        } catch (error) {
            console.error('Error al buscar las llamadas:', error.message);
            setMessage('Error al buscar las llamadas');
        }
    };

    const exportToExcel = async () => {
        if (results.length === 0) {
            console.log('No hay resultados para exportar.');
            return;
        }

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Llamadas');

        // Agregar las cabeceras al archivo de Excel
        const headers = Object.keys(results[0]);
        worksheet.addRow(headers);

        // Agregar los datos al archivo de Excel
        results.forEach((llamada) => {
            const values = Object.values(llamada);
            worksheet.addRow(values);
        });

        // Crear el archivo Excel y descargarlo
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'llamadas.xlsx';
        a.click();
        URL.revokeObjectURL(url);
    };
    // Obtener la lista de usuarios desde el servidor

    useEffect(() => {
        const listarUsuarios = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/user/allusers`);
                const usuariosData = response.data.map((name) => ({ name }));
                setUsuarios(usuariosData);
            } catch (error) {
                console.error('Error al obtener la lista de usuarios:', error.message);
            }
        };
        listarUsuarios();
    }, []);

    return (
        <Auth>
            {({ nombreUsuario, isAdmin}) => (
                <div><Nav />
                    <div className="llamadas-container">

                        <h3 className="llamadas-h3">Bienvenido {nombreUsuario}</h3>
                        <h2 className="llamadas-h2">Crear o buscar llamada</h2>
                        <form onSubmit={registrarLlamada}>

                            <label className='tituloInputLlamadas' htmlFor="nombre">Nombre:</label>
                            <input className='inputLlamadas'
                                type="text"
                                id="nombre"
                                value={nombre}
                                onChange={(e) => cambiarValores(setNombre, e.target.value)}
                            />

                            <label className='tituloInputLlamadas' htmlFor="apellidos">Apellidos:</label>
                            <input className='inputLlamadas'
                                type="text"
                                id="apellidos"
                                value={apellidos}
                                onChange={(e) => cambiarValores(setApellidos, e.target.value)}
                            />

                            <label className='tituloInputLlamadas' htmlFor="telefono">Teléfono:</label>
                            <input className='inputLlamadas'
                                type="number"
                                pattern="[0-9]*"
                                id="telefono"
                                value={telefono}
                                onChange={(e) => cambiarValores(setTelefono, e.target.value)}
                            />

                            <label className='tituloInputLlamadas' htmlFor="mail">Mail:</label>
                            <input className='inputLlamadas'
                                type="mail"
                                id="mail"
                                value={mail}
                                onChange={(e) => cambiarValores(setMail, e.target.value)}
                            />

                            <label className='tituloInputLlamadas' htmlFor="nivel_estudios">Nivel de estudios:</label>
                            <select className='inputLlamadas'
                                id="nivel_estudios"
                                name="nivel_estudios"
                                value={nivel_estudios}
                                onChange={(e) => setNivelEstudios(e.target.value)}
                            >
                                <option value="">SELECCIONA UNA OPCIÓN</option>
                                <option value="NO FACILITA">NO FACILITA</option>
                                <option value="SIN ESTUDIOS">SIN ESTUDIOS</option>
                                <option value="ESO">ESO</option>
                                <option value="BACHILLER">BACHILLER</option>
                                <option value="SUPERIOR">SUPERIOR</option>
                            </select>

                            <label className='tituloInputLlamadas' htmlFor="nivel_ingles">Nivel de inglés:</label>
                            <select className='inputLlamadas'
                                id="nivel_ingles"
                                name="nivel_ingles"
                                value={nivel_ingles}
                                onChange={(e) => setNivelIngles(e.target.value)}
                            >
                                <option value="">SELECCIONA UNA OPCIÓN</option>
                                <option value="NO FACILITA">NO FACILITA</option>
                                <option value="A1">A1</option>
                                <option value="A2">A2</option>
                                <option value="B1">B1</option>
                                <option value="B2">B2</option>
                                <option value="C1">C1</option>
                                <option value="C2">C2</option>
                            </select>

                            <label className='tituloInputLlamadas' htmlFor="curso_interes">Curso de interés:</label>
                            <select className='inputLlamadas'
                                id="curso_interes"
                                name="curso_interes"
                                value={curso_interes}
                                onChange={(e) => setCursoInteres(e.target.value)}
                            >
                                <option value="">SELECCIONA UNA OPCIÓN</option>
                                <option value="NO FACILITA">NO FACILITA</option>
                                <option value="ADMINISTRACION">ADMINISTRACION</option>
                                <option value="AGRARIO">AGRARIO</option>
                                <option value="EDUCACION">EDUCACION</option>
                                <option value="EMPRENDIMIENTO">EMPRENDIMIENTO</option>
                                <option value="HOSTELERIA">HOSTELERIA</option>
                                <option value="IDIOMAS">IDIOMAS</option>
                                <option value="INFORMATICA">INFORMATICA</option>
                                <option value="LOGISTICA-ALMACEN">LOGISTICA-ALMACEN</option>
                                <option value="OPOSICIONES">OPOSICIONES</option>
                                <option value="SANIDAD">SANIDAD</option>
                                <option value="TRANSPORTE">TRANSPORTE</option>
                                <option value="TURISMO">TURISMO</option>
                                <option value="RESIDUOS">RESIDUOS</option>
                                <option value="PSICOONCOLOGIA">PSICOONCOLOGIA</option>
                                <option value="PEDIATRIA">PEDIATRIA</option>
                                <option value="COMUNICACION">COMUNICACION</option>

                            </select>

                            <label className='tituloInputLlamadas' htmlFor="como_conocio">Como nos conocio:</label>
                            <select className='inputLlamadas'
                                id="como_conocio"
                                name="como_conocio"
                                value={como_conocio}
                                onChange={(e) => setComoConocio(e.target.value)}
                            >
                                <option value="">SELECCIONA UNA OPCIÓN</option>
                                <option value="NO FACILITA">NO FACILITA</option>
                                <option value="OFICINA">OFICINA</option>
                                <option value="REDES SOCIALES">REDES SOCIALES</option>
                                <option value="PUBLICIDAD">PUBLICIDAD</option>
                                <option value="CONOCIDO">CONOCIDO</option>
                            </select>

                            <label className='tituloInputLlamadas' htmlFor="grupo_joven">Grupo joven:</label>
                            <select className='inputLlamadas'
                                id="grupo_joven"
                                name="grupo_joven"
                                value={grupo_joven}
                                onChange={(e) => setGrupoJoven(e.target.value)}
                            >
                                <option value="">SELECCIONA UNA OPCIÓN</option>
                                <option value="SI">SI</option>
                                <option value="NO">NO</option>

                            </select>


                            <label className='tituloInputLlamadas' htmlFor="trabaja">Situación laboral:</label>
                            <select className='inputLlamadas'
                                id="trabaja"
                                name="trabaja"
                                value={trabaja}
                                onChange={(e) => setTrabaja(e.target.value)}
                            >
                                <option value="">SELECCIONA UNA OPCIÓN</option>
                                <option value="NO FACILITA">NO FACILITA</option>
                                <option value="DESEMPLEADO">DESEMPLEADO</option>
                                <option value="OCUPADO">OCUPADO</option>
                                <option value="AUTONOMO">AUTONOMO</option>
                                <option value="EMPRESA">EMPRESA</option>
                            </select>


                            <label className='tituloInputLlamadas' htmlFor="sector">Sector de interés:</label>
                            <select className='inputLlamadas'
                                id="sector"
                                name="sector"
                                value={sector}
                                onChange={(e) => setSector(e.target.value)}
                            >
                                <option value="">SELECCIONA UNA OPCIÓN</option>
                                <option value="NO FACILITA">NO FACILITA</option>
                                <option value="ADMINISTRACION">ADMINISTRACION</option>
                                <option value="AGRARIAS">AGRARIAS</option>
                                <option value="AGUA">AGUA</option>
                                <option value="ARTES GRAFICAS">ARTES GRAFICAS</option>
                                <option value="AUTONOMO">AUTONOMO</option>
                                <option value="COMERCIO Y MARKETING">COMERCIO Y MARKETING</option>
                                <option value="DESEMPLEADO">DESEMPLEADO</option>
                                <option value="EDIFICACIÓN Y OBRA CIVIL">EDIFICACIÓN Y OBRA CIVIL</option>
                                <option value="EDUCACION">EDUCACION</option>
                                <option value="ENERGIA">ENERGIA</option>
                                <option value="HOSTELERIA Y TURISMO">HOSTELERIA Y TURISMO</option>
                                <option value="IMAGEN PERSONAL">IMAGEN PERSONAL</option>
                                <option value="IMAGEN Y SONIDO">IMAGEN Y SONIDO</option>
                                <option value="INDUSTRIAS ALIMENTARIAS">INDUSTRIAS ALIMENTARIAS</option>
                                <option value="INFORMATICA">INFORMATICA</option>
                                <option value="MADERA MUEBLE Y CORCHO">MADERA MUEBLE Y CORCHO</option>
                                <option value="MEDIOAMBIENTE">MEDIOAMBIENTE</option>
                                <option value="METAL">METAL</option>
                                <option value="QUIMICA">QUIMICA</option>
                                <option value="SANIDAD">SANIDAD</option>
                                <option value="SEGURIDAD">SEGURIDAD</option>
                                <option value="SERVICIOS - OTROS">SERVICIOS - OTROS</option>
                                <option value="SERVICIOS A LAS EMPRESAS">SERVICIOS A LAS EMPRESAS</option>
                                <option value="SERVICIOS SOCIALES">SERVICIOS SOCIALES</option>
                                <option value="TEXTIL CONFECCION Y PIEL">TEXTIL CONFECCION Y PIEL</option>
                                <option value="TRANSPORTES">TRANSPORTES</option>
                                <option value="FUNCIONARIO">FUNCIONARIO</option>
                                <option value="INGENIERIA">INGENIERIA</option>
                            </select>



                            <label className='tituloInputLlamadas' htmlFor="comentarios">Comentarios:</label>
                            <select className='inputLlamadas'
                                id="comentarios"
                                name="comentarios"
                                value={comentarios}
                                onChange={(e) => setComentarios(e.target.value)}
                            >
                                <option value="">SELECCIONA UNA OPCIÓN</option>
                                <option value="NO FACILITA">NO FACILITA</option>
                                <option value="RESIDE EN OTRA PROVINCIA">RESIDE EN OTRA PROVINCIA</option>
                                <option value="ENVIAR INFORMACION">ENVIAR INFORMACION</option>
                                <option value="YA ES ALUMNO">YA ES ALUMNO</option>
                                <option value="CUALEGA NO QUIERE QUE SE LE LLAME ">CUALEGA NO QUIERE QUE SE LE LLAME </option>
                            </select>

                            <label className='tituloInputLlamadas' htmlFor="provincia">Provincia:</label>
                            <select className='inputLlamadas'
                                id="provincia"
                                name="provincia"
                                value={provincia}
                                onChange={(e) => setProvincia(e.target.value)}
                            >
                                <option value="">SELECCIONA UNA OPCIÓN</option>
                                <option value="NO FACILITA">NO FACILITA</option>
                                <option value="ALBACETE">ALBACETE</option>
                                <option value="ALICANTE">ALICANTE</option>
                                <option value="ALMERÍA">ALMERÍA</option>
                                <option value="ARABA">ARABA</option>
                                <option value="ASTURIAS">ASTURIAS</option>
                                <option value="AVILA">AVILA</option>
                                <option value="BADAJOZ">BADAJOZ</option>
                                <option value="BALEARES">BALEARES</option>
                                <option value="BARCELONA">BARCELONA</option>
                                <option value="BIZKAIA">BIZKAIA</option>
                                <option value="BURGOS">BURGOS</option>
                                <option value="CACERES">CACERES</option>
                                <option value="CADIZ">CADIZ</option>
                                <option value="CANTABRIA">CANTABRIA</option>
                                <option value="CASTELLON">CASTELLON</option>
                                <option value="CEUTA MELILLA">CEUTA MELILLA</option>
                                <option value="CIUDAD REAL">CIUDAD REAL</option>
                                <option value="CORDOBA">CORDOBA</option>
                                <option value="CORUÑA">CORUÑA</option>
                                <option value="CUENCA">CUENCA</option>
                                <option value="GIPUZKOA">GIPUZKOA</option>
                                <option value="GIRONA">GIRONA</option>
                                <option value="GRANADA">GRANADA</option>
                                <option value="GUADALAJARA">GUADALAJARA</option>
                                <option value="HUELVA">HUELVA</option>
                                <option value="HUESCA">HUESCA</option>
                                <option value="JAEN">JAEN</option>
                                <option value="LA RIOJA">LA RIOJA</option>
                                <option value="LAS PALMAS">LAS PALMAS</option>
                                <option value="LEON">LEON</option>
                                <option value="LLEIDA">LLEIDA</option>
                                <option value="LUGO">LUGO</option>
                                <option value="MADRID">MADRID</option>
                                <option value="MALAGA">MALAGA</option>
                                <option value="MURCIA">MURCIA</option>
                                <option value="NAVARRA">NAVARRA</option>
                                <option value="OURENSE">OURENSE</option>
                                <option value="PALENCIA">PALENCIA</option>
                                <option value="PONTEVEDRA">PONTEVEDRA</option>
                                <option value="SALAMANCA">SALAMANCA</option>
                                <option value="SANTA CRUZ DE TENERIFE">SANTA CRUZ DE TENERIFE</option>
                                <option value="SEGOVIA">SEGOVIA</option>
                                <option value="SEVILLA">SEVILLA</option>
                                <option value="SORIA">SORIA</option>
                                <option value="TARRAGONA">TARRAGONA</option>
                                <option value="TERUEL">TERUEL</option>
                                <option value="TOLEDO">TOLEDO</option>
                                <option value="VALENCIA">VALENCIA</option>
                                <option value="VALLADOLID">VALLADOLID</option>
                                <option value="ZAMORA">ZAMORA</option>
                                <option value="ZARAGOZA">ZARAGOZA</option>
                                <option value="EXTRANJERO">EXTRANJERO</option>
                            </select>

                            <label className='tituloInputLlamadas' htmlFor="otros_comentarios">Otros comentarios:</label>
                            <textarea
                                className='inputLlamadas'
                                id="otros_comentarios"
                                value={otros_comentarios}
                                onChange={(e) => cambiarValores(setOtrosComentarios, e.target.value)}
                                style={{ width: '100%', height: '150px' }}
                            />


                            <label className='tituloInputLlamadas' htmlFor="fechaInicio">Fecha de inicio:</label>
                            <input className='inputLlamadas'
                                type="date"
                                id="fechaInicio"
                                value={fechaInicio}
                                onChange={(e) => setFechaInicio(e.target.value)}
                            />

                            <label className='tituloInputLlamadas' htmlFor="fechaFin">Fecha de fin:</label>
                            <input className='inputLlamadas'
                                type="date"
                                id="fechaFin"
                                value={fechaFin}
                                onChange={(e) => setFechaFin(e.target.value)}
                            />


                            {isAdmin && (
                                <div className="admin-filter">
                                    <label className='tituloInputLlamadas' htmlFor="usuario">Filtrar por usuario:</label>
                                    <select className='inputLlamadas'
                                        id="usuario"
                                        value={usuarioSeleccionado}
                                        onChange={(e) => setUsuario(e.target.value)}
                                    >
                                        <option value="">Todos los usuarios</option>
                                        {usuarios.map((user) => (
                                            <option key={user.name} value={user.name}>
                                                {user.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            )}


                            <button type="submit" className="llamadas-create-button" >Crear Llamada</button>
                        </form>

                        <form onSubmit={buscarLlamada}>
                            <button type="submit" className="llamadas-search-button">Buscar</button>
                        </form>
                        <button onClick={exportToExcel} className="llamadas-export">Exportar a Excel</button>
                        {message && <p className='llamadas-p'>{message}</p>}
                        {results.length > 0 && (
                            <div>
                                <h2 className="llamadas-h2">Resultados de búsqueda:</h2>
                                <ul  className="llamadas-ul">
                                    {results.map((llamada) => (
                                        <li className="llamadas-li" key={llamada.id_llamada}>
                                            <strong>ID:</strong> {llamada.id_llamada}<br />
                                            <strong>Fecha de última llamada:</strong>{" "}
                                            {new Date(llamada.ultima_llamada).toLocaleDateString()}<br />
                                            <strong>Nombre:</strong> {llamada.nombre} {llamada.apellidos}<br />
                                            <strong>Email:</strong> {llamada.mail}<br />
                                            <strong>Nivel de estudios:</strong> {llamada.nivel_estudios}<br />
                                            <strong>Nivel de Inglés:</strong> {llamada.nivel_ingles}<br />
                                            <strong>Curso de interés:</strong> {llamada.curso_interes}<br />
                                            <strong>¿Cómo nos conoció?:</strong> {llamada.como_conocio}<br />
                                            <strong>¿Es usted grupo joven?:</strong> {llamada.grupo_joven}<br />
                                            <strong>¿Trabaja actualmente?:</strong> {llamada.trabaja}<br />
                                            <strong>Sector de interés:</strong> {llamada.sector}<br />
                                            <strong>Comentarios:</strong> {llamada.comentarios}<br />
                                            <strong>Provincia:</strong> {llamada.provincia}<br />
                                            <strong>Otros comentarios:</strong> {llamada.otros_comentarios}<br />
                                            <strong>Usuario:</strong> {llamada.usuario}
                                            <div className='llamadas-botonEditar'>
                                                <Link to={`/edit/${llamada.id_llamada}`}>Editar</Link>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}
                    </div>
                </div>

            )}
        </Auth>

    );
};

export default Llamadas;
